module.exports = __webpack_public_path__ + "img/await-order.c4e589c9.png";